import avatar1 from "../../../assets/images/user/avatar-1.jpg";
import avatar2 from "../../../assets/images/user/avatar-2.jpg";
import avatar3 from "../../../assets/images/user/avatar-3.jpg";
import avatar4 from "../../../assets/images/user/avatar-4.jpg";
import avatar5 from "../../../assets/images/user/avatar-5.jpg";

const chatData = [
  {
    id: 1,
    name: "Alia",
    thumb: avatar1,
    recent: false,
    unread: "3",
    excerpt: "online",
    chatHistory: [
      {
        0: {
          from: ["Tom got a small piece of pie."],
          to: [
            "I'd rather be a bird than a fish.",
            "They got there early, and they got really good seats."
          ]
        },
        1: {
          from: [
            "If I don’t like something, I’ll stay away from it.",
            "I want more detailed information."
          ],
          to: ["We need to rent a room for our party."]
        }
      }
    ]
  },
  {
    id: 2,
    name: "Domnic Brown",
    thumb: avatar2,
    recent: true,
    excerpt: "9:04 PM",
    chatHistory: [
      {
        0: {
          from: ["The sky is clear", "How was the math test?"],
          to: ["She always speaks to him in a loud voice."]
        },
        1: {
          from: [
            "The memory we used to share is no longer coherent.",
            "The mysterious diary records the voice.",
            "The old apple revels in its authority."
          ],
          to: ["Please wait outside of the house."]
        }
      }
    ]
  },
  {
    id: 3,
    name: "Domnic Harris",
    thumb: avatar3,
    recent: false,
    excerpt: "2:14 AM",
    chatHistory: [
      {
        0: {
          from: ["Tom got a small piece of pie."],
          to: [
            "I'd rather be a bird than a fish.",
            "They got there early, and they got really good seats."
          ]
        },
        1: {
          from: [
            "If I don’t like something, I’ll stay away from it.",
            "I want more detailed information."
          ],
          to: ["We need to rent a room for our party."]
        }
      }
    ]
  },
  {
    id: 4,
    name: "Garry Sobars",
    thumb: avatar4,
    recent: true,
    time: "Yesterday",
    excerpt: "Will connect you",
    chatHistory: [
      {
        0: {
          from: ["The sky is clear", "How was the math test?"],
          to: ["She always speaks to him in a loud voice."]
        },
        1: {
          from: [
            "The memory we used to share is no longer coherent.",
            "The mysterious diary records the voice.",
            "The old apple revels in its authority."
          ],
          to: ["Please wait outside of the house."]
        }
      }
    ]
  },
  {
    id: 5,
    name: "Jeson Born",
    thumb: avatar5,
    recent: true,
    time: "Friday",
    excerpt: "online",
    chatHistory: [
      {
        0: {
          from: ["Tom got a small piece of pie."],
          to: [
            "I'd rather be a bird than a fish.",
            "They got there early, and they got really good seats."
          ]
        },
        1: {
          from: [
            "If I don’t like something, I’ll stay away from it.",
            "I want more detailed information."
          ],
          to: ["We need to rent a room for our party."]
        }
      }
    ]
  },
  {
    id: 6,
    name: "Jimmy Jo",
    thumb: avatar1,
    recent: false,
    time: "Thrusday",
    excerpt: "Okay",
    chatHistory: [
      {
        0: {
          from: ["The sky is clear", "How was the math test?"],
          to: ["She always speaks to him in a loud voice."]
        },
        1: {
          from: [
            "The memory we used to share is no longer coherent.",
            "The mysterious diary records the voice.",
            "The old apple revels in its authority."
          ],
          to: ["Please wait outside of the house."]
        }
      }
    ]
  },
  {
    id: 7,
    name: "John Smith",
    thumb: avatar2,
    recent: true,
    time: "Thrusday",
    excerpt: "Who you are?",
    chatHistory: [
      {
        0: {
          from: ["Tom got a small piece of pie."],
          to: [
            "I'd rather be a bird than a fish.",
            "They got there early, and they got really good seats."
          ]
        },
        1: {
          from: [
            "If I don’t like something, I’ll stay away from it.",
            "I want more detailed information."
          ],
          to: ["We need to rent a room for our party."]
        }
      }
    ]
  },
  {
    id: 8,
    name: "Kadir M",
    thumb: avatar3,
    recent: false,
    time: "Tuesday",
    excerpt: "Welcome",
    chatHistory: [
      {
        0: {
          from: ["The sky is clear", "How was the math test?"],
          to: ["She always speaks to him in a loud voice."]
        },
        1: {
          from: [
            "The memory we used to share is no longer coherent.",
            "The mysterious diary records the voice.",
            "The old apple revels in its authority."
          ],
          to: ["Please wait outside of the house."]
        }
      }
    ]
  },
  {
    id: 9,
    name: "Jimmy Jon",
    thumb: avatar4,
    recent: false,
    time: "",
    excerpt: "online",
    chatHistory: [
      {
        0: {
          from: ["Tom got a small piece of pie."],
          to: [
            "I'd rather be a bird than a fish.",
            "They got there early, and they got really good seats."
          ]
        },
        1: {
          from: [
            "If I don’t like something, I’ll stay away from it.",
            "I want more detailed information."
          ],
          to: ["We need to rent a room for our party."]
        }
      }
    ]
  },
  {
    id: 10,
    name: "Stella Johnson",
    thumb: avatar5,
    recent: false,
    time: "",
    excerpt: "Okay",
    chatHistory: [
      {
        0: {
          from: ["The sky is clear", "How was the math test?"],
          to: ["She always speaks to him in a loud voice."]
        },
        1: {
          from: [
            "The memory we used to share is no longer coherent.",
            "The mysterious diary records the voice.",
            "The old apple revels in its authority."
          ],
          to: ["Please wait outside of the house."]
        }
      }
    ]
  }
];

export default chatData;
